<template>
     <div class="column inputBox" style="position: relative;">
      
          <div class="icon">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M14.3853 15.4453C13.0375 16.5222 11.3284 17.0422 9.60922 16.8984C7.88999 16.7546 6.29108 15.9579 5.14088 14.6721C3.99068 13.3862 3.3765 11.7087 3.42449 9.98413C3.47248 8.25957 4.17898 6.61883 5.39891 5.39891C6.61883 4.17898 8.25956 3.47248 9.98413 3.42449C11.7087 3.3765 13.3862 3.99068 14.6721 5.14088C15.9579 6.29108 16.7546 7.88999 16.8984 9.60922C17.0422 11.3284 16.5222 13.0375 15.4453 14.3853L20.6013 19.5403C20.675 19.609 20.7341 19.6918 20.7751 19.7838C20.8161 19.8758 20.8381 19.9751 20.8399 20.0758C20.8417 20.1765 20.8232 20.2765 20.7855 20.3699C20.7477 20.4633 20.6916 20.5482 20.6204 20.6194C20.5492 20.6906 20.4643 20.7467 20.3709 20.7845C20.2775 20.8222 20.1775 20.8407 20.0768 20.8389C19.9761 20.8371 19.8768 20.8151 19.7848 20.7741C19.6928 20.7331 19.61 20.674 19.5413 20.6003L14.3853 15.4453ZM6.45933 13.8833C5.72537 13.1493 5.22549 12.2142 5.02284 11.1961C4.8202 10.178 4.92391 9.12277 5.32084 8.16363C5.71778 7.20449 6.39014 6.38455 7.25295 5.80743C8.11575 5.23031 9.13027 4.92191 10.1683 4.92121C11.2063 4.92052 12.2213 5.22755 13.0848 5.80351C13.9484 6.37947 14.6219 7.1985 15.0201 8.1571C15.4183 9.11571 15.5235 10.1708 15.3222 11.1892C15.1209 12.2075 14.6223 13.1433 13.8893 13.8783L13.8843 13.8833L13.8793 13.8873C12.8944 14.87 11.5598 15.4215 10.1685 15.4207C8.77725 15.42 7.44318 14.867 6.45933 13.8833Z" fill="#1A2C4E" fill-opacity="0.3"/></svg>
          </div>
          
          <input
              class="searchInput"
              style="margin: 0;transition: none;"              
              ref="input"
              :class="{inputIcon: current.id, noBottomBorder: items.length, round, inputIconRound:round && current.id}"                           
              type="text"               
              v-model="searchText"
              :placeholder="placeholder || 'Location'"              
              @input="search">
          
              <!-- @keydown.down="focusHandler" 
              @keydown.up="focusHandler" 
              @keydown.enter.prevent="focusHandler" -->
              
          <!-- clear -->
          <div class="clearicon pointer click" v-if="searchText && !round" @click="clear()"><span>×</span></div>
          <div class="cleariconround pointer click" v-if="searchText && round" @click="clear()"><span>×</span></div>
          
        </div>

        <!-- 

          <Search v-model="query" placeholder="Search" class="w300" height="300px"/>
         -->
</template>
<script>
export default {
   
    data: function () {return {
      current:{},
      timer: undefined,
      items: [],
      focus: null,
      searchText: undefined,
      
    }},

    
    props: {
      modelValue: Number,
      placeholder: String,           
      height: {type:String, default:'300px'},      
      delay: {type: Number, default:0},
      round:Boolean,
    },

    mounted() {
      if (this.modelValue){
        // 
      }
    },

    computed: {
      value(){        
        return `${this.current.name}, ${this.countryTitle[this.current.country]}`
      },

      country(){        
        return this.current.country
      }
    },

    methods: {
      keydowns(){
        console.log('key enter')
      },
      focusHandler(event) {
        switch (event.keyCode) {
          case 13:
            if (!this.focus) {
              this.current = this.items[0]
              this.update()
              return
            }             
              this.current = this.items[this.focus]
              this.update()            
              return
          case 38:
            if (this.focus === null) {
              this.focus = 0;
            } else if (this.focus > 0) {
              this.focus--;
            }
            break;
          case 40:
            if (this.focus === null) {
              this.focus = 0;
            } else if (this.focus < this.items.length - 1) {
              this.focus++;
            }
            break;
        }
      },

      out(){
        console.log('outside')
        this.items=[]
        // this.clear()
      },
      clear(){
        this.current = {}
        this.searchText = undefined
        this.$emit('update:modelValue', undefined)  
        this.$emit('update', undefined)        
        this.$emit('country', undefined)
        this.$emit('city', undefined)
        this.$emit('state', undefined)
        this.items = []
      },
      
       update() {
        this.$emit('update:modelValue', this.current.id)  
        this.$emit('update', this.current)
        this.$emit('country', this.current.country)
        this.$emit('city', this.current.name)
        this.$emit('state', this.current.state)
        if (this.current.country == 'us' && this.current.state){
          this.searchText = `${this.current.name}, ${this.current.state.toUpperCase()}`        
        } else{
          this.searchText = `${this.current.name}, ${this.countryTitle[this.current.country]}`        
        }
        
        // this.dict.cities[this.current.id] = this.current
        this.items = []
      },

      // input
      async wait(fn, delay = 300) {
            return ((...args) => {
              clearTimeout(this.timer);
                this.timer = setTimeout(() => {
                this.timer = null
                fn(...args)
                }, delay)
            })()
      },

      updateValue(e) {
        // console.log('input', e.target.value)
        // this.wait(() => { }, this.delay);
      },



      async search(){
        let res = await this.api.send('geo', {q: this.searchText})
        
      console.log(res)
      if (res.error){
        console.log(res.error)        
        return
      }
      this.items = res.resp
      /* {
		    "country": "it",
		    "flag": "🇮🇹",
		    "id": 3171457,
		    "name": "Parma"
		  }, */
    },


    },
}
</script>

<style scoped>
.item {
  font-size: 15px;
  margin-top: -1px;
  margin-left: 2px;
}
.rounditem {
  font-size: 13px;
  margin-top: -1px;
  margin-left: 2px;
}

.inputBox {
  margin: 0px 0 12px;
  margin: 0px 0 0px;
}

.round{
  padding: 3px 16px; 
  border-radius: 50px; 
  font-size: 13px; 
  width: 100%;
}

/* input */
.autocomplete {
  display: flex;
  flex-direction: column;
  overflow-y: scroll;
  overflow-x: hidden;
  background-color: var(--back);
  position: absolute;
  z-index: 1000;
  /* margin-top: 30px; */
  text-align: left;
  align-items: flex-start;
  justify-content: flex-start;
  border-top: 1px dashed var(--g1);
}

.itembox {
  cursor: pointer;
  display: flex;
  flex-direction: row;
  text-align: left;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
  /* background-color: var(--back); */
  background: var(--input);
  padding: 2px 0px 2px 6px;
}

.itembox:hover, .itembox.active {
  background-color: var(--g1);
}

/* .autocomplete div p {
  padding: 2px 8px;
  text-align: left;
} */

.noBottomBorder {
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
}
.round.noBottomBorder {
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
  border-top-left-radius: 15px;
  border-top-right-radius: 15px;
}

.text {
  width: 100%;
  position: relative;
  padding: 0px 0;
  margin: 0;
}

.input {
  padding: 5px 12px 8px;
  border-radius: 8px;
  background: var(--g05);
}

.clear {
  background: none;
}

.inputIcon {
  padding-left: 50px;
}

.icon {
  height: 20px;
  width: auto;
  position: absolute;
  top: 11px;
  left: 12px;
  border-radius: 4px;
}

.inputIconRound {
  padding-left: 38px;
}

.roundicon {
  height: 18px;
width: auto;
position: absolute;
top: 7px;
left: 9px;
border-radius: 4px;
}

.clearicon {
  cursor: pointer;
  user-select: none;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 22px;
  width: 22px;
  position: absolute;
  top: 11px;
  right: 7px;
  border-radius: 100px;
  background-color: var(--g1);
}

.clearicon span {
  position: absolute;
  font-size: 12px;
  font-weight: 500;
  color: var(--g3);
  margin-top: -1px;
}

.cleariconround {
  cursor: pointer;
-webkit-user-select: none;
-moz-user-select: none;
user-select: none;
display: flex;
align-items: center;
justify-content: center;
height: 17px;
width: 17px;
position: absolute;
top: 7px;
right: 10px;
border-radius: 100px;
background-color: var(--g1);
}

.cleariconround span {
  position: absolute;
font-size: 12px;
font-weight: 500;
color: var(--g3);
margin-top: -1px;
margin-left: 1px;
}

.iconpadding {
  padding-left: 30px;
}

div.focus {
  border: 1px solid blue;
}

</style>

